import * as React from 'react';
import * as styles from './help.module.scss';
import TableOfContents from './table-of-contents';
import { AppContext } from '../../shared/app-context';
import useHelp from '../../hooks/useHelp';
import CircularProgress from '@material-ui/core/CircularProgress';
import useSearch from '../../hooks/useSearch';
import SearchBar from '../common/search-bar';
import useTimedAlerts from '../../hooks/useTimedAlerts';
import PriorityTwoFailure from '../announcement/priority-two-failure';

/**
 * Help
 * @function Help - Outer component for the help page
 */
const Help = () => {
  const { state } = React.useContext(AppContext);
  const { loading, documents, fetchHelpDocuments } = useHelp();
  const { searchQuery, updateSearchQuery, isSearching, setIsSearching } = useSearch();
  const { errorMessage, setErrorMessage } = useTimedAlerts();

  React.useEffect(() => {
    fetchHelpDocuments(state.clientId);
  }, []);

  return (
    <div className={styles.helpContainer}>
      {errorMessage && <PriorityTwoFailure message={errorMessage} />}
      <div className={styles.header}>
        <h1>Help Documentation</h1>
        <SearchBar
          value={searchQuery}
          updateValue={(val: string) => updateSearchQuery(val)}
          setIsSearching={(searching: boolean) => setIsSearching(searching)}
          placeholder={'Help Documentation'}
        />
      </div>
      {loading ? (
        <div className={styles.circularProgress}>
          <CircularProgress />
        </div>
      ) : (
        <TableOfContents
          documents={documents}
          searchQuery={searchQuery}
          isSearching={isSearching}
          setIsSearching={(searching: boolean) => setIsSearching(searching)}
          setErrorMessage={setErrorMessage}
        />
      )}
    </div>
  );
};

export default Help;
